/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Yup from 'yup'

export type Values = {
  [key: string]: string | Array<string> | CommentBox | RichTextCommentBox
  rework_points: Array<string>
  commentDetails: RichTextCommentBox
  feedback: string
}

export function getInitialValues(feedbackOptions: ReworkAreasInput): Values {
  const result: Values = {
    rework_points: [],
    commentDetails: {
      comment: '',
      attachments: [],
      plainText: 0,
    },
    feedback: '',
  }

  feedbackOptions.forEach(feedbackOption => {
    const key = `${feedbackOption.key}_options`

    result[key] = []
  })

  return result
}

export const getFeedbackValidationSchema = (
  options: ReworkAreasInput,
  category: ProjectCategory
): Yup.ObjectSchema => {
  const schema: Record<string, any> = {}

  if (category !== 'others') {
    schema.rework_points = Yup.array()
      .of(Yup.string())
      .min(1)
      .required('Please Select at least 1 item')
      .nullable()
    options.forEach(option => {
      if (option.key === 'flag_creator') {
        schema[`${option.key}_options`] = Yup.array().when(`rework_points`, {
          is: value => !value.includes(option.key),
          then: Yup.array().nullable(),
          otherwise: Yup.array().of(Yup.string()).nullable(),
        })
      } else {
        schema[`${option.key}_options`] = Yup.array().when(`rework_points`, {
          is: value => !value.includes(option.key),
          then: Yup.array().nullable(),
          otherwise: Yup.array()
            .of(Yup.string())
            .min(1, 'Please select at least 1 item')
            .required('This field is required')
            .nullable(),
        })
      }
    })

    schema.feedback = Yup.string()
      .label('Comment')
      .max(1800, 'Comment must be less than 1800 characters long.')
      .nullable()
  }

  schema.commentDetails = Yup.object().shape({
    plainText: Yup.number().max(
      1500,
      'Comment must be less than 1500 characters long.'
    ),
  })
  return Yup.object({ ...schema })
}
